module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "exam-content m0 cb pr mt15"
  }, [_c('article', {
    staticClass: "fl exam-left"
  }, [_c('h3', {
    staticClass: "tc h3"
  }, [_vm._v(_vm._s(_vm.examPaperList.name))]), _vm._v(" "), _c('div', {
    staticClass: "paperIntroduce mb30"
  }, [_c('el-row', {
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('span', [_vm._v("试卷总分: " + _vm._s(_vm.totalScore) + " 分")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('span', [_vm._v("试卷总题数: " + _vm._s(_vm.totalQutestionNumber))]), _vm._v(" "), _c('span', {
    staticClass: "ml10"
  }, [_vm._v("道")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('span', [_vm._v("难易程度 " + _vm._s(_vm.jiandannumber) + ":" + _vm._s(_vm.putongnumber) + ":" + _vm._s(_vm.kunnannumber))]), _vm._v(" "), _c('span', {
    staticClass: "ml10"
  }, [_vm._v("( 简单: 普通 :困难)")])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "mt10",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('span', [_vm._v("考试时长: " + _vm._s(_vm.duration))]), _vm._v(" "), _c('span', {
    staticClass: "ml10"
  }, [_vm._v("分钟")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [(_vm.examTimes == -1) ? _c('span', [_vm._v("考试次数: 不限")]) : _vm._e(), _vm._v(" "), (_vm.examTimes != -1) ? _c('span', [_vm._v("考试次数: " + _vm._s(_vm.examTimes) + " 次")]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "exam-nav"
  }, [_c('ul', {
    staticClass: "m0"
  }, [(_vm.questionList1.length > 0) ? _c('li', {
    staticClass: "first"
  }, [_c('a', {
    class: {
      active: _vm.type == '001001'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.menuBtn('001001')
      }
    }
  }, [_vm._v("单选题")])]) : _vm._e(), _vm._v(" "), (_vm.questionList2.length > 0) ? _c('li', [_c('a', {
    class: {
      active: _vm.type == '001002'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.menuBtn('001002')
      }
    }
  }, [_vm._v("多选题")])]) : _vm._e(), _vm._v(" "), (_vm.questionList3.length > 0) ? _c('li', [_c('a', {
    class: {
      active: _vm.type == '001003'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.menuBtn('001003')
      }
    }
  }, [_vm._v("判断题")])]) : _vm._e(), _vm._v(" "), (_vm.questionList4.length > 0) ? _c('li', [_c('a', {
    class: {
      active: _vm.type == '001004'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.menuBtn('001004')
      }
    }
  }, [_vm._v("填空题")])]) : _vm._e(), _vm._v(" "), (_vm.questionList5.length > 0) ? _c('li', [_c('a', {
    class: {
      active: _vm.type == '001005'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.menuBtn('001005')
      }
    }
  }, [_vm._v("简答题")])]) : _vm._e(), _vm._v(" "), (_vm.questionList6.length > 0) ? _c('li', [_c('a', {
    class: {
      active: _vm.type == '001006'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.menuBtn('001006')
      }
    }
  }, [_vm._v("案例题")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "examOverscroll fl"
  }, [_c('div', {
    staticClass: "option-question m0 active"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == '001001'),
      expression: "type == '001001'"
    }]
  }, _vm._l((_vm.questionList1), function(questionsItem, index) {
    return _c('div', {
      key: index,
      staticClass: "option-div"
    }, [_c('i', {
      staticClass: "fl mr10 active"
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('h2', {
      staticClass: "f14 fl",
      domProps: {
        "innerHTML": _vm._s(questionsItem.content)
      }
    }, [_vm._v("( )" + _vm._s(questionsItem.content))]), _vm._v(" "), _vm._l((questionsItem.choices), function(choicesItem, index) {
      return _c('div', {
        key: index,
        staticClass: "option-list-radio ml40 cb"
      }, [_c('div', {
        staticClass: "oh"
      }, [_c('el-radio', {
        attrs: {
          "label": choicesItem.code
        },
        model: {
          value: (questionsItem.userAnswer),
          callback: function($$v) {
            _vm.$set(questionsItem, "userAnswer", $$v)
          },
          expression: "questionsItem.userAnswer"
        }
      }, [_c('span', {
        staticClass: "mr10"
      }, [_vm._v(_vm._s(choicesItem.code))]), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(choicesItem.content)
        }
      })])], 1)])
    })], 2)
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == '001002'),
      expression: "type == '001002'"
    }]
  }, [_c('p', {
    staticClass: "explainText mt20 pl10"
  }, [_vm._v("一、" + _vm._s(_vm.questionDescription["001002"]))]), _vm._v(" "), _vm._l((_vm.questionList2), function(questionsItem, index) {
    return _c('div', {
      key: index,
      staticClass: "option-div"
    }, [_c('i', {
      staticClass: "fl mr10 active"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('h2', {
      staticClass: "f14 fl mb15",
      domProps: {
        "innerHTML": _vm._s(questionsItem.content)
      }
    }, [_vm._v("( )" + _vm._s(questionsItem.content))]), _vm._v(" "), _c('div', {
      staticClass: "option-list-radio ml40 cb"
    }, [_c('el-checkbox-group', {
      on: {
        "change": _vm.handleCheckedCitiesChange
      },
      model: {
        value: (questionsItem.userAnswer),
        callback: function($$v) {
          _vm.$set(questionsItem, "userAnswer", $$v)
        },
        expression: "questionsItem.userAnswer"
      }
    }, _vm._l((questionsItem.choices), function(choicesItem, index) {
      return _c('el-checkbox', {
        key: index,
        attrs: {
          "label": choicesItem.code
        }
      }, [_c('span', {
        staticClass: "mr10"
      }, [_vm._v(_vm._s(choicesItem.code))]), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(choicesItem.content)
        }
      })])
    }), 1)], 1)])
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == '001003'),
      expression: "type == '001003'"
    }]
  }, [_c('p', {
    staticClass: "explainText mt20 pl10"
  }, [_vm._v("一、" + _vm._s(_vm.questionDescription["001003"]))]), _vm._v(" "), _vm._l((_vm.questionList3), function(questionsItem, index) {
    return _c('div', {
      key: index,
      staticClass: "option-div"
    }, [_c('i', {
      staticClass: "fl mr10 active"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('h2', {
      staticClass: "f14 fl",
      domProps: {
        "innerHTML": _vm._s(questionsItem.content)
      }
    }, [_vm._v("( )" + _vm._s(questionsItem.content))]), _vm._v(" "), _vm._l((questionsItem.choices), function(choicesItem, index) {
      return _c('div', {
        key: index,
        staticClass: "option-list-radio ml40 cb"
      }, [_c('div', {
        staticClass: "oh"
      }, [_c('el-radio', {
        attrs: {
          "label": choicesItem.code
        },
        model: {
          value: (questionsItem.userAnswer),
          callback: function($$v) {
            _vm.$set(questionsItem, "userAnswer", $$v)
          },
          expression: "questionsItem.userAnswer"
        }
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(choicesItem.content)
        }
      }, [_vm._v(_vm._s(choicesItem.code) + " " + _vm._s(choicesItem.content))])])], 1)])
    })], 2)
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == '001004'),
      expression: "type == '001004'"
    }]
  }, [_c('p', {
    staticClass: "explainText mt20 pl10"
  }, [_vm._v("一、" + _vm._s(_vm.questionDescription["001004"]))]), _vm._v(" "), _vm._l((_vm.questionList4), function(questionsItem, index) {
    return _c('div', {
      key: index,
      staticClass: "option-div option-div-tk"
    }, [_c('div', {
      staticClass: "question-box"
    }, [_c('i', {
      staticClass: "fl mr10 active"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('h2', {
      staticClass: "f14 fl",
      domProps: {
        "innerHTML": _vm._s(questionsItem.content)
      }
    }, [_vm._v("( )" + _vm._s(questionsItem.content))])]), _vm._v(" "), _c('p', _vm._l((questionsItem.blanksNumbers), function(blanksNumbersItem, index) {
      return _c('el-input', {
        key: index,
        staticClass: "mt30 mb10 ml10",
        attrs: {
          "type": "text",
          "label": blanksNumbersItem.code
        },
        model: {
          value: (questionsItem.userAnswer),
          callback: function($$v) {
            _vm.$set(questionsItem, "userAnswer", $$v)
          },
          expression: "questionsItem.userAnswer"
        }
      })
    }), 1)])
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == '001005'),
      expression: "type == '001005'"
    }]
  }, [_c('p', {
    staticClass: "explainText mt20 pl10"
  }, [_vm._v("一、" + _vm._s(_vm.questionDescription["001005"]))]), _vm._v(" "), _vm._l((_vm.questionList5), function(questionsItem, index) {
    return _c('div', {
      key: index,
      staticClass: "option-div"
    }, [_c('div', {
      staticClass: "question-box"
    }, [_c('i', {
      staticClass: "fl mr10 active"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('h2', {
      staticClass: "f14 fl",
      domProps: {
        "innerHTML": _vm._s(questionsItem.content)
      }
    }, [_vm._v("( )" + _vm._s(questionsItem.content))])]), _vm._v(" "), _c('div', {
      staticClass: "textarea"
    }, [_c('el-input', {
      attrs: {
        "type": "textarea"
      },
      model: {
        value: (questionsItem.userAnswer),
        callback: function($$v) {
          _vm.$set(questionsItem, "userAnswer", $$v)
        },
        expression: "questionsItem.userAnswer"
      }
    })], 1)])
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type == '001006'),
      expression: "type == '001006'"
    }]
  }, [_c('p', {
    staticClass: "explainText mt20 pl10"
  }, [_vm._v("一、" + _vm._s(_vm.questionDescription["001006"]))]), _vm._v(" "), _vm._l((_vm.questionList6), function(questionsItem, index) {
    return _c('div', {
      key: index,
      staticClass: "option-div"
    }, [_c('div', {
      staticClass: "question-box"
    }, [_c('i', {
      staticClass: "fl mr10 active"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('h2', {
      staticClass: "f14 fl",
      domProps: {
        "innerHTML": _vm._s(questionsItem.content)
      }
    }, [_vm._v("( )" + _vm._s(questionsItem.content))])]), _vm._v(" "), _c('div', {
      staticClass: "textarea"
    }, [_c('el-input', {
      attrs: {
        "type": "textarea"
      },
      model: {
        value: (questionsItem.userAnswer),
        callback: function($$v) {
          _vm.$set(questionsItem, "userAnswer", $$v)
        },
        expression: "questionsItem.userAnswer"
      }
    })], 1)])
  })], 2)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-4ba7b837"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/personal/ExamPaperPreview.vue
// module id = 1150
// module chunks = 41